// KONTRAK lintas-layar (pemilik: kelompok "nota-rute"). v1: A.openRoute(id) di public/js/ops.js.
import { useRouteOps } from './ops.js';

/** Buka detail Rute Kirim (Rekap Loading & Surat Jalan Tagihan). Dipakai pencarian global & Operasi. */
export function useOpenRoute(): (id: number) => Promise<void> {
  const { openRoute } = useRouteOps();
  return openRoute;
}
